import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { AuthProvider } from 'react-oidc-context';
import { WebStorageStateStore } from 'oidc-client-ts';

// Validação das variáveis de ambiente obrigatórias
const requiredEnvVars = {
  REACT_APP_COGNITO_AUTHORITY: process.env.REACT_APP_COGNITO_AUTHORITY,
  REACT_APP_COGNITO_CLIENT_ID: process.env.REACT_APP_COGNITO_CLIENT_ID,
  REACT_APP_COGNITO_REDIRECT_URI: process.env.REACT_APP_COGNITO_REDIRECT_URI,
};

// Verificar se as variáveis obrigatórias estão definidas
const missingVars = Object.entries(requiredEnvVars)
  .filter(([key, value]) => !value)
  .map(([key]) => key);

if (missingVars.length > 0) {
  console.error('Variáveis de ambiente obrigatórias não encontradas:', missingVars);
  console.error('Valores atuais:', requiredEnvVars);
}

// Garantir que o redirect_uri termine com /callback
const baseRedirectUri = process.env.REACT_APP_COGNITO_REDIRECT_URI || '';
const redirectUri = baseRedirectUri.endsWith('/callback') 
  ? baseRedirectUri 
  : `${baseRedirectUri.replace(/\/$/, '')}/callback`;

const cognitoAuthConfig = {
  authority: process.env.REACT_APP_COGNITO_AUTHORITY,
  client_id: process.env.REACT_APP_COGNITO_CLIENT_ID,
  redirect_uri: redirectUri,
  response_type: process.env.REACT_APP_COGNITO_RESPONSE_TYPE || 'code',
  scope: process.env.REACT_APP_COGNITO_SCOPE || 'openid email profile',
  // Persistência: evita "sumir" auth state em alguns cenários de reload/navegação.
  userStore: new WebStorageStateStore({ store: window.localStorage }),
  // Garante que, após o processamento do callback, a URL fique "limpa"
  // (sem code/state) e não prenda o app em /callback.
  onSigninCallback: () => {
    window.history.replaceState({}, document.title, '/');
  },
};

const root = ReactDOM.createRoot(document.getElementById('root'));

// wrap the application with AuthProvider
root.render(
  <React.StrictMode>
    <AuthProvider {...cognitoAuthConfig}>
      <App />
    </AuthProvider>
  </React.StrictMode>
);